import { render } from "./task-aaj.vue?vue&type=template&id=02c8ce6a&scoped=true"
import script from "./task-aaj.vue?vue&type=script&lang=js"
export * from "./task-aaj.vue?vue&type=script&lang=js"

import "./task-aaj.vue?vue&type=style&index=0&id=02c8ce6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c8ce6a"]])

export default __exports__